import { styled } from '@grupoboticario/flora-react';

export const NotFoundTitle = styled('h1', {
   textTransform: "uppercase",
   marginBottom: "15px"
});

export const NotFoundDescription = styled('p', {
   paddingTop: "10px",
   fontSize: "18px"
});

export const NotFoundBox = styled('section', {
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
   justifyContent: "center",
   height: "calc(100vh - 94px)"
});

export const BoxOptions = styled('section', {
    display: "flex",  
    alignItems: "center", 
    gap: "20px",
    marginTop: "20px"
 });